export const TUTORIAL_STAGES_TOTAL = 4;
export const TUTORIAL_LEVELS = [
    {
        id: 1,
        title: "First defense",
        subtitle: "Place your first towers and survive 5 waves.",
        allowedTowers: ["archer"],
        requiredWaves: 5,
        rewards: ["cannon", "economy"],
        hints: [
            { wave: 1, text: "Pick the Archer below (1) and click an empty cell to place it." },
            { wave: 2, text: "Press [Space] between waves to start the next round earlier." },
            { wave: 4, text: "Click any tower to upgrade or sell it for a refund." },
        ],
    },
    {
        id: 2,
        title: "Splash and economy",
        subtitle: "Use Cannons against grouped mobs and Sat Mines to scale income.",
        allowedTowers: ["archer", "cannon", "economy"],
        requiredWaves: 7,
        rewards: ["frost", "poison"],
        hints: [
            { wave: 1, text: "Cannons deal splash damage — great against grouped weak mobs." },
            { wave: 3, text: "Sat Mines generate passive income — invest early for late-wave power." },
        ],
    },
    {
        id: 3,
        title: "Control the field",
        subtitle: "Use Frost to slow and Poison for sustained damage.",
        allowedTowers: ["archer", "cannon", "economy", "frost", "poison"],
        requiredWaves: 8,
        rewards: ["support", "lightning"],
        hints: [
            { wave: 1, text: "Frost slows enemies, giving other towers more time to fire." },
            { wave: 3, text: "Poison ticks damage over time — pair it with crowd control." },
        ],
    },
    {
        id: 4,
        title: "Skies and chains",
        subtitle: "Lightning chains, Support buffs nearby towers. Watch for flyers.",
        allowedTowers: ["archer", "cannon", "economy", "frost", "poison", "support", "lightning"],
        requiredWaves: 10,
        rewards: ["antiair"],
        hints: [
            { wave: 1, text: "Lightning chains between nearby enemies — best in chokepoints." },
            { wave: 3, text: "Support towers buff range and damage of neighbors but don't attack." },
            { wave: 6, text: "Flyers incoming — most towers ignore them. Anti-Air will be your reward." },
        ],
    },
];
export function getTutorialLevel(id) {
    return TUTORIAL_LEVELS.find((l) => l.id === id);
}
export function isOnboarded(tutorialStage) {
    return tutorialStage >= TUTORIAL_STAGES_TOTAL;
}
export function nextTutorialLevelId(tutorialStage) {
    if (tutorialStage >= TUTORIAL_STAGES_TOTAL)
        return null;
    return tutorialStage + 1;
}
//# sourceMappingURL=tutorial.js.map